/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 31/3/2023
 */

import { Close } from "@mui/icons-material";
import { Button, IconButton, OutlinedInput, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import ImageUploader from "../Shared/ImageUploader";
import { useState } from "react";
import { toast } from "react-toastify";
import CategoryList from "../Shared/CategoryList";

import styles from "./AddCategory.module.css"
import { useCreateCategoryMutation } from "../../Store/Services/CategoryService";
import { useDeleteCategoryFolderMutation } from "../../Store/Services/ImageService";

const schema = yup.object().shape({
    categoryName: yup.string().required(),
    categoryDisplayName: yup.string().required(),
});

const AddCategory = ({ handleClose }) => {

    const [images, setImages] = useState([]);
    const [catName, setCatName] = useState('')
    const [openCatList, setOpenCatList] = useState(false)
    const [selectedCat, setSelectedCat] = useState(null)

    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(schema),
    });

    const [createCategory] = useCreateCategoryMutation();

    const onSubmit = async (data) => {
        console.log('category form data: ', data)
        const dataSet = {
            ...data,
            categoryParent: selectedCat
        }
        if(images.length!==0){
            try {
                const addCategory = await createCategory(dataSet).unwrap();
                console.log('add category', addCategory)
                // toast.success("Category successfully added!");
            } catch (err) {
                console.error('Failed to save the category: ', err)
                toast.error("Erorr, something went wrong!", { position: "bottom-right" });
            }
            handleClose()
        }
    }

    const [deleteImgFolder] = useDeleteCategoryFolderMutation();

    const closeDialog = async() => {
      await deleteImgFolder().unwrap();
      handleClose()
    }

    return (
        <div>
            <div className={styles.headingContainer}>
                <Typography fontWeight={600} variant={"h6"}>Add Category</Typography>
                <IconButton className={styles.closeButton} onClick={() => closeDialog()}><Close /></IconButton>
            </div>

            <form onSubmit={handleSubmit(onSubmit)}>
                <div className={styles.formItem}>
                    <label className={styles.formLabel}>Name:</label>
                    {errors.categoryName && errors.categoryName.type === "required" && <span className={styles.validation} > *</span>}
                    <OutlinedInput
                        {...register("categoryName")}
                        className={styles.formInput}
                        placeholder="Enter Category Name"
                        size="small"
                        fullWidth
                    />
                </div>

                <div className={styles.formItem}>
                    <label className={styles.formLabel}>Dispaly Name:</label>
                    {errors.categoryDisplayName && errors.categoryDisplayName.type === "required" && <span className={styles.validation} > *</span>}
                    <OutlinedInput
                        {...register("categoryDisplayName")}
                        className={styles.formInput}
                        placeholder="Enter Display Name"
                        size="small"
                        fullWidth
                    />
                </div>

                <div className={styles.formItem}>
                    <label className={styles.formLabel}>Parent Category:</label>
                    <OutlinedInput
                        // {...methods.register("catParent")}
                        // onChange={(e) => {methods.setValue('catParent', selectedParent); console.log(selectedParent)}}
                        className={styles.formInput}
                        placeholder="Enter Parent Category"
                        size="small"
                        onClick={() => setOpenCatList(true)}
                        autoComplete='off'
                        fullWidth
                        value={catName}
                    />
                </div>

                <div className={styles.formItem}>
                    <label className={styles.formLabel}>Images:</label>
                    {images.length===0 && <span className={styles.validation} > *</span>}
                    <ImageUploader images={images} setImages={setImages} from="cat" />
                </div>

                {/* Submit Button */}
                <div className={styles.buttonContainer}>
                    <Button type="submit" className={styles.submitButton} variant="contained">Save</Button>
                </div>
            </form>
            <CategoryList open={openCatList} onClose={() => setOpenCatList(false)} setSelectedCat={setSelectedCat} selectedCat={selectedCat} setCatName={setCatName} />
        </div>
    )
}

export default AddCategory
